import { useAPI } from '@/services';

interface IUseMelliAccountEligibility {
  isEligibleForMelliAccount: boolean;
  isLoading: boolean;
}

export const useGetMelliAccountEligibility =
  (): IUseMelliAccountEligibility => {
    const { data, isLoading } = useAPI(
      ['fundTransfer', 'getMelliCardEligibility'],
      {
        reactQueryOptions: {
          retry: false,
          refetchOnWindowFocus: false,
        },
      }
    );
    // Determine if user should view melli withdraw flow.
    const isEligibleForMelliAccount = !!data?.isAllow;

    return {
      isEligibleForMelliAccount,
      isLoading,
    };
  };
